import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  GetCartablesResponse,
  GetSaleItemsResponse,
} from "../../models/cartable.model";
import { ApiResultModel, PageInfoModel } from "../../models/common.model";
import { PaginationInfo } from "../../models/security.model";
import { GetCartables, GetSaleItems } from "../../services/cartable.service";
import FilesStatus from "../loan/filesStatus";
import SaleSettlementList from "./components/SaleSettlementList";
import { setstateCartable } from "../../redux/activeState/activeStateAction";

const SaleSettlement = () => {
  const [cartableData, setCartableData] = useState<GetCartablesResponse[]>([]);
  const [saleItems, setSaleItems] = useState<GetSaleItemsResponse[]>([]);
  const [paginationInfo, setPaginationInfo] = useState<PageInfoModel>();
  const history = useHistory<{
    settlementData?: {
      saleKey: string;
      key?: string;
      branchId?: number;
      customerPersonId?: number;
    };
  }>();
  const dispatch = useDispatch();
  const saleCartableState = useSelector((state: any) => state.stateCartable);
  const state =
    cartableData.length > 0
      ? cartableData[0].state
      : saleCartableState.stateCartable;

  const [filter, setFilter] = useState<{
    state: string;
    customerNationalCode: string;
  }>();
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    }
  );
  const [fetchItems, setFetchItems] = useState(false);

  // service call
  const { mutate: GetCartablesMutate } = useMutation(GetCartables, {
    onSuccess: (data: GetCartablesResponse[]) => {
      if (data) {
        setCartableData(data);
        dispatch(
          setstateCartable({
            stateCartable: data[0]?.state,
          })
        );
        setFetchItems(true);
      }
    },
    onError: () => {},
  });
  const { mutate: GetSaleItemsMutate } = useMutation(GetSaleItems, {
    onSuccess: (data: ApiResultModel<GetSaleItemsResponse[]>) => {
      if (data) {
        setSaleItems(data.data);
        setPaginationInfo(data.pageInfo);
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    GetCartablesMutate({ workflowType: "SaleSettlement" });
  }, []);

  useEffect(() => {
    if (fetchItems) {
      GetSaleItemsMutate({
        filter: {
          state: state || "WaitForConfirm",
          customerNationalCode: filter?.customerNationalCode,
        },
        paginationInfo: currentPaginationInfo,
      });
    }
  }, [filter, currentPaginationInfo, fetchItems]);

  const handleClickRow = (item: GetSaleItemsResponse) => {
    sessionStorage.setItem(
      "SETTLEMENT_REQUEST_DATA",
      JSON.stringify({ saleKey: item?.referenceKey })
    );
    history.push({
      pathname: "/StoreRequestDetail",
      state: {
        settlementData: { saleKey: item?.referenceKey },
      },
    });
  };

  if (cartableData.length === 0) {
    return (
      <div>
        <img
          className='classCenter'
          style={{ width: "30%", margin: "auto", marginTop: "5vh" }}
          src='images/empthuCartable.png'
          alt=''
        />
      </div>
    );
  }

  return (
    <div>
      <FilesStatus
        workFlowType='SupplierRequirements'
        cartableData={cartableData}
        title={"وضعیت فروشنده ها"}
      />
      <SaleSettlementList
        saleItems={saleItems}
        currentPaginationInfo={currentPaginationInfo}
        setCurrentPaginationInfo={setCurrentPaginationInfo}
        paginationInfo={paginationInfo!}
        setFilter={setFilter}
        filter={filter!}
        handleClickRow={handleClickRow}
      />
    </div>
  );
};

export default SaleSettlement;
